'use strict';
const mmWidgets = require('../widgets/mm-widgets'),
	NODE_SIZE_BOUNDS = {min: 30, max: 1000};

mmWidgets.fn.themeStyleNodeWidthWidget = function (mapThemeModel) {
	const getCurrentSize = (themeNodeStyle) => {
			const size = mapThemeModel.getThemeAttribute(['node'], [themeNodeStyle, 'default'], ['text', 'maxWidth']);
			return parseFloat(size) || false;
		},
		setSize = (themeNodeStyle, size) => {
			mapThemeModel.overrideThemeAttribute(['node', themeNodeStyle, 'text', 'maxWidth'], size || undefined);
		},
		incrementNodeWidth = (themeNodeStyle, increment) => {
			const current = getCurrentSize(themeNodeStyle),
				newSize = current + increment;

			if (newSize < NODE_SIZE_BOUNDS.min) {
				setSize(themeNodeStyle, NODE_SIZE_BOUNDS.min);
			} else if (newSize > NODE_SIZE_BOUNDS.max) {
				setSize(themeNodeStyle, NODE_SIZE_BOUNDS.max);
			} else {
				setSize(themeNodeStyle, newSize);
			}
		},
		increment = function (themeNodeStyle) {
			incrementNodeWidth(themeNodeStyle, 10);
		},
		decrement = function (themeNodeStyle) {
			incrementNodeWidth(themeNodeStyle, -10);
		},
		reset = (themeNodeStyle) => {
			setSize(themeNodeStyle, false);
		},
		actions = {increment, decrement, reset};

	return mmWidgets.each(this, function () {
		const widget = this;
		widget.click(() => {
			const themeNodeStyle = widget.attr('data-mm-theme-node-width'),
				operation = widget.attr('data-mm-node-width');
			actions[operation](themeNodeStyle);
		});
	});
};

